import type { PILOT_THIRD_PARTY_SENSORS_CARD_FRENCH_LOCALE } from "~ui/@application/locales/modules/components/pilot-third-party-sensors-card/pilot-third-party-sensors-card.fr.ts";

export const PILOT_THIRD_PARTY_SENSORS_CARD_ENGLISH_LOCALE = {
  title: "Third party sensors",
} satisfies typeof PILOT_THIRD_PARTY_SENSORS_CARD_FRENCH_LOCALE;
